import React from 'react';
import Select, { MultiValue } from 'react-select';

export interface MultiselectFieldOption {
  value: string;
  label: string;
}

export interface MultiselectFieldProps {
  id: string;
  label: string;
  value: string[];
  onChange?: (value: string[]) => void;
  options: MultiselectFieldOption[];
  disabled?: boolean;
  required?: boolean;
  onFocus?: () => void;
  onBlur?: () => void;
  hasValue?: boolean;
  getFloatingLabelStyle: (
    fieldName: string,
    hasValue: boolean
  ) => React.CSSProperties;
  getFloatingInputStyle: (
    isTextarea: boolean,
    fieldName: string
  ) => React.CSSProperties;
  styles: Record<string, React.CSSProperties>;
}

const MultiselectField: React.FC<MultiselectFieldProps> = ({
  id,
  label,
  value,
  onChange,
  options,
  disabled = false,
  required = false,
  onFocus,
  onBlur,
  hasValue,
  getFloatingLabelStyle,
  getFloatingInputStyle,
  styles,
}) => {
  const selectOptions = options.map(option => ({
    value: option.value,
    label: option.label,
  }));
  const selectedOptions = selectOptions.filter(opt =>
    value.includes(opt.value)
  );

  const handleChange = (
    selected: MultiValue<{ value: string; label: string }>
  ) => {
    const selectedValues = selected.map(opt => opt.value);
    onChange?.(selectedValues);
  };

  return (
    <div style={styles.floatingFieldContainer}>
      <Select
        inputId={id}
        value={selectedOptions}
        onChange={handleChange}
        options={selectOptions}
        isMulti
        isDisabled={disabled}
        onFocus={onFocus}
        onBlur={onBlur}
        placeholder="Select..."
        menuPortalTarget={document.body}
        styles={{
          control: base => ({ ...base, ...getFloatingInputStyle(false, id) }),
          menuPortal: base => ({ ...base, zIndex: 10001 }),
        }}
      />
      <label
        htmlFor={id}
        style={getFloatingLabelStyle(
          id,
          hasValue ?? (value && value.length > 0)
        )}>
        {label}
        {required && <span style={{ color: 'red' }}>*</span>}
      </label>
    </div>
  );
};

export default React.memo(MultiselectField);
